import { desc } from "./desc";

export const getSorting = (order: SortOrder, orderBy: string) =>
  order === "desc"
    ? (a: any, b: any) => desc(a, b, orderBy)
    : (a: any, b: any) => -desc(a, b, orderBy);
